module.exports = __webpack_public_path__ + "img/53029a3ad0aadbd3570a4e3c99c6216b.png";